// Запит оцінки в Google Play через рідне вікно (In-App Review API).
// Показуємо в момент радості — після УСПІШНО зданого іспиту, а не випадково.
//
// Важливо про поведінку Google:
//  • Google САМ вирішує, показати вікно чи ні (квота ~раз на місяць на юзера).
//    Якщо не показав — жодної помилки, просто нічого не сталося.
//  • Хто вже залишив оцінку — тому Google вікно не показує. Нам відстежувати не треба.
//  • Дізнатися, чи юзер поставив оцінку, API не дає — і не має давати.
// Тому свої ліміти — щоб не смикати API дарма і не набридати.
import { isNativeApp } from './push';

const LAST_ASK_KEY = 'reviewLastAsk';
const PASSED_KEY = 'reviewPassedCount';
const MIN_PASSED = 2; // спершу нехай складе іспит хоча б двічі
const COOLDOWN_DAYS = 21;

function num(key: string): number {
  try {
    return Number(localStorage.getItem(key) || 0);
  } catch {
    return 0;
  }
}

/** Викликати ПІСЛЯ успішно зданого іспиту. Сам вирішує, чи доречно просити. */
export async function maybeAskForReview(passed: boolean): Promise<void> {
  if (!passed || !isNativeApp()) return;
  try {
    const passedCount = num(PASSED_KEY) + 1;
    localStorage.setItem(PASSED_KEY, String(passedCount));
    if (passedCount < MIN_PASSED) return;

    const last = num(LAST_ASK_KEY);
    if (last && Date.now() - last < COOLDOWN_DAYS * 24 * 60 * 60 * 1000) return;

    const { InAppReview } = await import('@capacitor-community/in-app-review');
    localStorage.setItem(LAST_ASK_KEY, String(Date.now()));
    // Невелика пауза — щоб юзер устиг побачити свій результат, а не вікно поверх нього
    await new Promise((r) => setTimeout(r, 1500));
    await InAppReview.requestReview();
  } catch {
    /* плагін недоступний (стара версія апки) або Google не показав — не критично */
  }
}
